export const appLoaders = {
	MAIN: 'main-loader',
};
